// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"0566f80b","159":"8c65e2e1","239":"ecafbeb4","389":"e404fc8e","453":"0c08887e","732":"1280ef32","977":"1152e106"}[chunkId] + ".chunk.js";
};